export const codesBrands: { [key: string]: string } = {
  '01': 'Atlas Copco',
  '04': 'Chicago Pneumatic',
  '06': 'Irmer Elze',
  '07': 'Liutech',
  '62': 'Gesan',
  '66': 'American Pneumatic Tools',
  '99': 'Common Parts',
};
